module.exports = __webpack_public_path__ + "img/project-setup-dd.a3f4cf40.png";